const themeLightPrimary = '#010205';

export { themeLightPrimary };
